(function () {
    angular.module('emarket.main.province', []);
}());

(function () {
    angular.module('emarket.main.province', []);
}());
